<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <label>Descrição</label>
        <input type="text" class="form-control" v-model="description" />
      </div>
      <div class="col-md-12 pt-0 pb-0"><ErrorsMessages :errors="errors" /></div>
      <div class="col-md-12 text-right">
        <confirmation-dialog
          class="mr-2"
          message-title="EXCLUIR?"
          message-body="Deseja realmente excluir o agrupamento?"
          open-class="btn-delete"
          open-left-icon="fa-trash"
          open-text="EXCLUIR"
          @yes="deleteGrouping"
        />
        <v-btn :disabled="loading" @click="update" class="btn-save">
          <i class="fas fa-check mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "SALVAR" }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages";

import ConfirmationDialog from "../../../../Components/ConfirmationDialog";

import api from "../../../../../services/api";

import toast from "../../../../../lib/ToastNotification";

export default {
  name: "Edit",
  components: {
    ErrorsMessages,
    ConfirmationDialog,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      description: "",
      loading: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    retrieve() {
      let { data } = this;

      this.description = data.description;
    },
    async deleteGrouping() {
      try {
        let data = { id: this.data.id };

        const response = await api.delete(
          "/rest-home/financial/configuration/grouping",
          {
            data,
          }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$bvModal.hide(`edit-grouping-${this.data.id}`);

          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async update() {
      try {
        this.loading = true;

        const { data, description } = this;

        let params = { id: data.id, description };

        const response = await api.put(
          "/rest-home/financial/configuration/grouping",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$bvModal.hide(`edit-grouping-${this.data.id}`);

          this.$emit("success");

          this.description = "";
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
